/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class */
import { Button, Icon, LearningPanelNotification } from 'learning-panel-components';
import { FC } from 'react';
import { translate } from 'translations';
import styles from './loginSso.module.scss';

const LoginSSO: FC<LoginSsoProps> = (props: LoginSsoProps) => {
    const { error } = props;
    const platformUrl = process.env.CB_PLATFORM_CLIENT_URL || window.location.origin;

    // Get the intended destination URL from sessionStorage (set by NetworkErrorsContainer)
    const returnUrl = sessionStorage.getItem('cbHistory') || '';

    // Build SSO URL with return parameter
    const ssoUrl = returnUrl
        ? `${platformUrl}/users/visitor/sso-sign-in?user_return_to=${encodeURIComponent(returnUrl)}`
        : `${platformUrl}/users/visitor/sso-sign-in`;

    return (
        <>
            <div>
                <img className={styles.bot} alt="cbLogoBot" src={`${process.env.PUBLIC_URL}/images/cbBot.svg`} />
            </div>
            <div className={styles['login-wrapper']}>
                <div className={styles.text}>{translate('welcomeBack')}</div>
                <a href={ssoUrl} id="login-with-sso">
                    <Button
                        type={'bigGradient'}
                        text={translate('LoginWithSSO')}
                        className={styles.button}
                        endIcon={<Icon name="sso" style={{ marginTop: '0.5rem' }} />}
                        lowerCase
                    />
                </a>
                {error && (
                    <div className={styles['general-error-wrapper']}>
                        (
                        <LearningPanelNotification
                            notificationText={error}
                            hasClose={false}
                            variant="error"
                            handleClose={() => undefined}
                            id="login-error"
                        />
                        )
                    </div>
                )}
            </div>
        </>
    );
};

interface LoginSsoProps {
    error: string;
}

export default LoginSSO;
